import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IBookingResponse } from "../../Orchestrator/Types/Types/BookingTypes";
import { SeatBookingPatchRequest } from "../../Orchestrator/Types/Types/Checkout/Seating/SeatBookingPatchRequest";

export async function patchBookingForSeatSelection(bookingId: string, seatBookingPatchRequest: SeatBookingPatchRequest, showLoader: boolean= true): Promise<IApiResponse<IBookingResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.patchBooking}/${bookingId}`;
    return await apiRequest<IBookingResponse>(endpoint, 'PATCH', {
        body: JSON.stringify(seatBookingPatchRequest)
    }, "none", undefined, undefined, showLoader);
}